var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"max-w-screen-sm mx-auto bg-gray-50 min-h-screen",attrs:{"id":"app"}},[_c('div',{attrs:{"id":"nav"}}),_c('transition',{attrs:{"name":"view"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }